import React, {Component} from 'react';
import {HashRouter as Router, Link} from 'react-router-dom';


class NotFound extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="card">
                <div className="card-block">

                    <div className="ex-page-content text-center">
                        <h1>404!</h1>
                        <h3>Beklager, siden blev ikke fundet</h3>
                        <br/>
                        <Link to="/" className="btn btn-primary mb-5 waves-effect waves-light">Tilbage til Dashboard</Link>
                    </div>

                </div>
            </div>
        );
    }
}

export default NotFound;


// WEBPACK FOOTER //
// ./web/src/components/NotFound.jsx